<template>
  <div class="iconArea" @click="onClick">
    <div class="iconWrap">
      <icon-image :iconUrl="iconUrl" />
    </div>
    <img v-if="iconFrame" class="iconFrame" :src="iconFrame" />
  </div>
</template>

<script lang="ts">
import { Vue, Component, Prop, Emit } from 'vue-property-decorator'
import type { StreamerUser } from '@/models/StreamerUser'
import { CurrentStatus, ConnectStatus } from '@/models/StreamerInfo'
import { Client, defaultNativeInterfaceClient } from '@/utils/NativeInterface'
import IconImage from '@/components/IconImage.vue'
import ImgUrl from '@/utils/ImgUrl'
import router from '@/router'

@Component({
  components: {
    IconImage,
  },
})
export default class StreamerIcon extends Vue {
  @Prop()
  streamer!: StreamerUser

  @Prop()
  currentStatus!: CurrentStatus | null

  @Prop({ default: 128 })
  iconSize!: number

  @Emit('firebaseEvent')
  firebaseEvent(stateType: string | null) {
    return stateType
  }

  get isBroadcasting(): boolean {
    const currentStatus = this.currentStatus
    if (
      currentStatus == null ||
      currentStatus.live == null ||
      currentStatus.connectStatus != ConnectStatus.broadcast
    ) {
      return false
    }
    return true
  }

  get iconFrame() {
    if (!this.isBroadcasting) {
      return null
    }

    const isChrome = navigator.userAgent.indexOf('Chrome') >= 0
    return isChrome
      ? '/img/onLiveFrameAnimation.webp'
      : '/img/onLiveFrameAnimation.png'
  }

  get iconUrl(): string {
    if (!this.streamer) return ''
    return ImgUrl.getIconUrlWithSize(this.streamer.iconUrl, this.iconSize) || ''
  }

  moveToProfile() {
    router.push({
      path: `/profile/${this.streamer.profileId}`,
    }).catch(() => {})
  }

  onClick() {
    const nativeInterface = defaultNativeInterfaceClient()
    if (nativeInterface.client === Client.native) {
      // webのプロフィールページに遷移する
      this.firebaseEvent(null)
      this.moveToProfile()
      return
    }

    try {
      const currentStatus = this.currentStatus
      if (!this.isBroadcasting) {
        // 配信中でない場合はプロフィールをnativeで開く
        this.firebaseEvent(null)
        nativeInterface.openProfile(this.streamer.profileId)
        return
      }

      // 配信中orコラボ中の場合は当該配信をnativeで開く
      const live = this.currentStatus!.live!
      this.firebaseEvent('live')
      nativeInterface.openLive(live.mediaId, live.broadcastingMethod)
    } catch {
      // 失敗したらwebでプロフィールを開く
      this.moveToProfile()
    }
  }
}
</script>

<style scoped>
.iconArea {
  display: flex;
  align-items: center;
  width: 52px;
}

.iconWrap {
  display: flex;
  width: 52px;
  padding: 0 4px;
}

.iconFrame {
  width: 52px;
  height: 52px;
  position: absolute;
}
</style>
